import {useRef, useState} from 'react';
import { makeStyles, Menu, MenuItem} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  dot: {
    marginLeft: 'auto',
    marginRight: 0,
    height: 24
  },
  menu: {},
  menuItem: {
    padding: 0
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 30,
    marginLeft: 30,
    width: '100%'
  }
}));

interface IProps {
  onRename: () => void,
  onDelete: () => void
}

function DotSidebar(props: IProps) {
  const classes = useStyles();
  const {onRename, onDelete} = props;
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const onClickRename = () => {
    setOpenMenu(false);
    onRename()
  };

  const onClickDelete = () => {
    setOpenMenu(false);
    onDelete();
  };

  return (
    <div className={classes.dot}>
      <img
        src={`/assets/icons/creatordashboard/dots.svg`}
        alt={'img'}
        ref={anchorRef}
        onClick={handleMenuOpen}
      />
      <Menu
        anchorEl={anchorRef.current}
        elevation={1}
        onClose={handleMenuClose}
        open={openMenu}
        PaperProps={{
          style: {width: 'auto', marginTop: 50, marginLeft: -40, borderRadius: 12}
        }}
      >
        {['Rename', 'Delete'].map((option, index) => (
          <MenuItem
            className={classes.menuItem}
            key={option}
            onClick={() => index === 0 ? onClickRename() : onClickDelete()}
          >
            <p className={classes.btn}>{option}</p>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default DotSidebar;